export * from './LabelTooltip';
export * from './LabelTooltip.type';
